import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { InvestmentStatusResources } from 'services/resources/catalogs/investment-status';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';

export const InvestmentStatusPage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(InvestmentStatusResources);

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.investment-status.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} hasCode m={8} />
    </>
  );
};
